import React, { FC } from "react";

import PersonalForm from "./PersonalForm";
import RegistrationHeading from "./RegistrationHeading";

// import style from "./PersonalStep.module.scss";

export const PersonalStep: FC = () => (
  <>
    <RegistrationHeading />
    <main>
      <PersonalForm />
    </main>
  </>
);
